/**
 * Skeleton Loaders - Precise replicas of actual components
 */

export const QuoteCardSkeleton = () => (
  <div className="flex items-center gap-4 p-4 border rounded-xl animate-pulse bg-white">
    <div className="w-10 h-10 bg-muted rounded-lg flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-5 bg-muted rounded w-3/4" />
      <div className="h-4 bg-muted rounded w-1/2" />
    </div>
    <div className="w-24 h-7 bg-muted rounded-full" />
    <div className="w-20 h-9 bg-muted rounded-lg" />
  </div>
);

export const PolicyCardSkeleton = () => (
  <div className="flex items-center gap-4 p-4 border rounded-xl animate-pulse bg-white">
    <div className="w-10 h-10 bg-muted rounded-lg flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-5 bg-muted rounded w-2/3" />
      <div className="h-4 bg-muted rounded w-1/3" />
    </div>
    <div className="h-5 bg-muted rounded w-32" />
    <div className="w-24 h-7 bg-muted rounded-full" />
    <div className="flex gap-2">
      <div className="w-16 h-9 bg-muted rounded-lg" />
      <div className="w-16 h-9 bg-muted rounded-lg" />
    </div>
  </div>
);

export const DocumentCardSkeleton = () => (
  <div className="flex items-center gap-4 p-4 border rounded-xl animate-pulse bg-white">
    <div className="w-10 h-10 bg-muted rounded-lg flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-5 bg-muted rounded w-3/5" />
      <div className="h-3 bg-muted rounded w-1/4" />
    </div>
    <div className="h-4 bg-muted rounded w-16" />
    <div className="w-24 h-7 bg-muted rounded-full" />
    <div className="w-24 h-4 bg-muted rounded" />
    <div className="w-20 h-9 bg-muted rounded-lg" />
  </div>
);

export const RequestCardSkeleton = () => (
  <div className="flex items-center gap-4 p-4 border rounded-xl animate-pulse bg-white">
    <div className="w-10 h-10 bg-muted rounded-lg flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <div className="h-5 bg-muted rounded w-4/5" />
      <div className="h-3 bg-muted rounded w-1/4" />
    </div>
    <div className="h-4 bg-muted rounded w-20" />
    <div className="w-28 h-7 bg-muted rounded-full" />
    <div className="h-4 bg-muted rounded w-32" />
    <div className="w-16 h-9 bg-muted rounded-lg" />
  </div>
);

export const DetailCardSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-8 bg-muted rounded w-1/2 mb-4" />
    <div className="h-4 bg-muted rounded w-1/3 mb-8" />
    <div className="space-y-6">
      <div className="border rounded-xl p-6 space-y-4">
        <div className="h-6 bg-muted rounded w-1/4 mb-4" />
        <div className="space-y-3">
          <div className="flex justify-between">
            <div className="h-4 bg-muted rounded w-1/4" />
            <div className="h-4 bg-muted rounded w-1/3" />
          </div>
          <div className="flex justify-between">
            <div className="h-4 bg-muted rounded w-1/4" />
            <div className="h-4 bg-muted rounded w-1/3" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const TableSkeleton = ({ rows = 5 }) => (
  <div className="rounded-lg border">
    <div className="bg-muted/50 p-4 border-b">
      <div className="flex gap-4">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-4 bg-muted rounded w-24" />
        ))}
      </div>
    </div>
    <div className="divide-y">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="p-4 flex items-center gap-4 animate-pulse">
          <div className="w-10 h-10 bg-muted rounded-lg" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-muted rounded w-3/4" />
            <div className="h-3 bg-muted rounded w-1/2" />
          </div>
          <div className="w-20 h-6 bg-muted rounded-full" />
          <div className="w-16 h-8 bg-muted rounded" />
        </div>
      ))}
    </div>
  </div>
);
